/**
 * Global Layout —— 包裹所有页面
 * 顺序：ErrorBoundary 最外层 → Nav → <main> page content → Footer + 第三方脚本
 * 对应「七横-错误观测」L2 第一层兜底
 */
import type { ReactNode } from 'react';
import ErrorBoundary from '@/renderer/ErrorBoundary';
import Nav from '@/components/layouts/Nav/Nav';
import Footer from '@/components/layouts/Footer/Footer';
import Analytics from '@/components/third-party/Analytics';
import Termly from '@/components/third-party/Termly';
import '@/styles/tokens.css';
import '@/styles/globals.css';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <Nav />
      <main>{children}</main>
      <Footer />
      <Analytics />
      <Termly />
    </ErrorBoundary>
  );
}
